import { useAuth } from '@/hooks/use-auth';
import { Redirect, Stack } from 'expo-router';

export default function AdminLayout() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (user?.role !== 'admin') {
    return <Redirect href="/(tabs)/activity" />;
  }

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="users" />
      <Stack.Screen name="invites" />
      <Stack.Screen name="pending-items" />
      <Stack.Screen name="edit-menu-item/[id]" />
      <Stack.Screen name="pending-businesses" />
      <Stack.Screen name="edit-business/[id]" />
    </Stack>
  );
}
